<template>
    <NcFooter class="px-4 py-2">
        <NcButton :disabled="disabled" expand="block" @click="$emit('update')">
            <mdicon name="content-save" size="small" class="mr-1" />
            <span>Opslaan</span>
        </NcButton>
    </NcFooter>
</template>
<script>
export default {
    props: ['disabled'],
}
</script>
<style lang="">

</style>
